import Vue from 'vue'
import MultiLanguage from 'vue-multilanguage'
import header from './header'
import login from './login'
import accountDatum from './accountDatum'
import userDatum from './userDatum'
import authOption from './authOption'
import addRoleDialog from './addRoleDialog'
import btn from './btn'
import select from './select'
import sidebarList from './sidebarList'
import table from './table'
import tableModelAccountList from './tableModel-account-list'
import tableModelUserList from './tableModel-user-list'
import tableModelAuthList from './tableModel-auth-list'
import tableModelChangeParentSales from './tableModel-change-parent-sales'
import relation from './relation'
import clientParentInfo from './clientParentInfo'
import salesCommission from './CommissionSetting/Sale/salesCommission'
import ibCommission from './CommissionSetting/IB/ibCommission'
import alertIgnore from './CommissionSetting/IB/alertIgnore'
import monthlyIBResult from './CommissionSetting/IB/monthlyIBResult'
import cpaIBResult from './CommissionSetting/IB/cpaIBResult'
import auditTrailReport from './CommissionSetting/IB/auditTrailReport'
import salesMonthlyResult from './CommissionSetting/Sale/salesMonthlyResult'
import realTimeReport from './CommissionSetting/IB/realTimeReport'
import spreadCommissionMappingReport from './CommissionSetting/IB/spreadCommissionMappingReport'
import allCommissionReport from './CommissionSetting/IB/allCommissionReport'
import commissionTable from './CommissionSetting/commissionTable'
import commissionSeek from './CommissionSetting/commissionSeek'
import ibCommissionRuleSetting from './CommissionSetting/IB/ibCommissionRuleSetting'
import ruleItem from './CommissionSetting/Sale/ruleItem'
import mtclient from './CommissionSetting/Sale/mtclient'

import profitShareView from './ProfitShareSetting/profitShareView';
import accountSetting from './ProfitShareSetting/accountSetting';
import profitShareReport from './ProfitShareSetting/profitShareReport';
import versionReport from './ProfitShareSetting/versionReport';


// 翻译 佣金设定
import commissionView from './CommissionSetting/commissionView'
import ibPrimary from './CommissionSetting/ibPrimary'
import salePrimary from './CommissionSetting/salePrimary'
import publicLan from './CommissionSetting/publicLan'
var LanguageArr = [header, login, accountDatum, userDatum, btn, select, sidebarList, table,
    tableModelAccountList, relation, salesCommission, ibCommission, monthlyIBResult, auditTrailReport, cpaIBResult, salesMonthlyResult, realTimeReport, commissionView,
    ibPrimary, salePrimary, publicLan, authOption, addRoleDialog, spreadCommissionMappingReport, allCommissionReport, commissionTable, commissionSeek,
    ibCommissionRuleSetting, ruleItem, mtclient, tableModelUserList, tableModelAuthList, tableModelChangeParentSales, profitShareView, accountSetting,
    profitShareReport, versionReport, clientParentInfo, alertIgnore
]
var LanguageData = {
    cn: {},
    hk: {},
    en: {}
}


// var LanguageData = (LanguageArr => LanguageKeys => LanguageKeys.map( (item,index) => ({[index]: LanguageArr[index]}) ) )(LanguageArr)
// console.log(LanguageData(LanguageKeys))

var LanguageKeys = Object.keys(LanguageData);

LanguageArr.forEach((item, index) => { // 重新合并对象
    LanguageKeys.forEach((lan) => {
        var key = [Object.keys(LanguageArr[index][lan])[0]]
        LanguageData[lan][key] = LanguageArr[index][lan][key]
    })
})

// 检测翻译
var allKey = {}
var detection = (obj, LanguageKey) => {
    var keys = Object.keys(obj)
    keys.forEach((item) => {
        if (Object.prototype.toString.call(obj[item]) == "[object Object]") {
            detection(obj[item], LanguageKey)
        }
        allKey[LanguageKey]++
    })
}
LanguageKeys.forEach((item) => {
    allKey[item] = 0
    detection(LanguageData[item], item)
})
console.log(allKey)
    // 检测翻译

Vue.use(MultiLanguage, LanguageData)



// WEBPACK FOOTER //
// ./src/MultiLanguage/index.js